import './GameBoardActivities/puzzleimg.css';
import {Component} from 'react';


class UnderCoverPuzzleCard extends Component {
       
    constructor(props) {
        super(props);
        this.state = {
            invisibleArr: [],
            layoutComplete: false,
            rowOffset: -2,
            columnOffset: 0,
            
        }; 
     }
    

   determineTopLeftPosition(){
        let row = Math.floor(+this.props.index / this.props.nbrColumns);
        let column = +this.props.index - (this.props.nbrColumns * row);
        this.top = row * this.props.totalHeightPx/this.props.nbrRows - this.state.rowOffset + "px";
        this.left = column * this.props.totalWidthPx/this.props.nbrColumns - 
            this.state.columnOffset + "px";
    }
       
    render() 
    {
        if (this.state.layoutComplete === false){
            this.determineTopLeftPosition();
        }
        if (this.props.invisibleArr.includes(this.props.index)){
              this.imageClass = 0;
        }else{
              this.imageClass = 100;
        }
            
                
    return <>
        <div style={{position: "absolute", left: this.left, top: this.top, opacity: this.imageClass}}>

            <div className="d-flex text-color-white h-100">

                <img className="cover-up-square" 
                     src="./assets/Activities/Vacation/coverUpSquare.png" alt="coverSquare" 
                         />
                </div>
            
        </div>
           
    </>
    }

    

}

export default UnderCoverPuzzleCard;